var map = {
	"./0xbtc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/0xbtc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a6f10a"
	],
	"./1inch.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/1inch.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-fa8e68"
	],
	"./1st.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/1st.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-64636a"
	],
	"./aave.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/aave.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e9669d"
	],
	"./abbc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/abbc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-07f2fd"
	],
	"./abt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/abt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f8a112"
	],
	"./ac3.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ac3.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2eaab8"
	],
	"./act.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/act.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b4784f"
	],
	"./ada.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ada.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-bcb0e5"
	],
	"./adb.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/adb.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ed6f48"
	],
	"./adx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/adx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ccc186"
	],
	"./ae.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ae.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-12f582"
	],
	"./aeon.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/aeon.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-038cbd"
	],
	"./aergo.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/aergo.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9fb4aa"
	],
	"./agi.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/agi.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-67a2cb"
	],
	"./aion.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/aion.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5ad2c3"
	],
	"./ait.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ait.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b0c6d7"
	],
	"./akro.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/akro.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-da73b6"
	],
	"./akt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/akt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5be7ba"
	],
	"./aleph.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/aleph.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-48c401"
	],
	"./algo.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/algo.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c0e0a1"
	],
	"./alis.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/alis.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-853568"
	],
	"./alpha.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/alpha.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-fceb09"
	],
	"./alx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/alx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d43d87"
	],
	"./amb.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/amb.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-989701"
	],
	"./amlt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/amlt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-88b8bc"
	],
	"./ampl.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ampl.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-6715a8"
	],
	"./anc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/anc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a0fd12"
	],
	"./anj.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/anj.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a3a5c7"
	],
	"./ankr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ankr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e2f55f"
	],
	"./ant.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ant.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ed44ee"
	],
	"./aph.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/aph.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-898317"
	],
	"./apl.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/apl.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-17feea"
	],
	"./appc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/appc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2f2a45"
	],
	"./apy.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/apy.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1b30d0"
	],
	"./ar.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ar.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5c92da"
	],
	"./ardr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ardr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d1ed5e"
	],
	"./ark.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ark.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a4448a"
	],
	"./arn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/arn.svg",
		"vendors-node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-i-fc7488"
	],
	"./aro.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/aro.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-882ee7"
	],
	"./arrr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/arrr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-059f2d"
	],
	"./ast.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ast.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c8f03b"
	],
	"./atmi.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/atmi.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-688c2f"
	],
	"./atom.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/atom.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-bc040c"
	],
	"./auc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/auc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-6bfd4d"
	],
	"./aura.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/aura.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-6702ee"
	],
	"./avax.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/avax.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-8c7b30"
	],
	"./awc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/awc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-94caf6"
	],
	"./axp.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/axp.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-af004d"
	],
	"./bac.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bac.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e7dd88"
	],
	"./bal.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bal.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f0e041"
	],
	"./bam.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bam.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5181f4"
	],
	"./band.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/band.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-041500"
	],
	"./bao.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bao.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-813d74"
	],
	"./bat.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bat.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2144ce"
	],
	"./bay.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bay.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5ca93a"
	],
	"./bbr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bbr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ed8e51"
	],
	"./bcd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bcd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-716955"
	],
	"./bch.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bch.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b75b37"
	],
	"./bcn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bcn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-0ed1c0"
	],
	"./bco.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bco.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-364887"
	],
	"./bf.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bf.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-08bd39"
	],
	"./bifi.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bifi.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e63e89"
	],
	"./bix.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bix.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-df740c"
	],
	"./block.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/block.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e34676"
	],
	"./blt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/blt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f49b80"
	],
	"./blue.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/blue.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f19e46"
	],
	"./blz.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/blz.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e94bc0"
	],
	"./bnb.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bnb.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7a8a02"
	],
	"./bnt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bnt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-83932c"
	],
	"./bond.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bond.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a37604"
	],
	"./bora.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bora.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-bf3dad"
	],
	"./box.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/box.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-6a0197"
	],
	"./bpt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bpt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3dc5ee"
	],
	"./bqx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bqx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-260b49"
	],
	"./brd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/brd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7f6a67"
	],
	"./btc++.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/btc++.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7e4653"
	],
	"./btc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/btc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5a66c7"
	],
	"./btcd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/btcd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7efb8a"
	],
	"./btcp.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/btcp.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-8ce2cb"
	],
	"./btg.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/btg.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c11d3c"
	],
	"./btmx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/btmx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a19601"
	],
	"./bto.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bto.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-23d4e5"
	],
	"./bts.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bts.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-6c3236"
	],
	"./btt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/btt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2e631b"
	],
	"./btu.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/btu.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4bda77"
	],
	"./bu.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bu.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-518abd"
	],
	"./busd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/busd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1c7f4e"
	],
	"./bwt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bwt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f85db4"
	],
	"./bz.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bz.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d2c6d2"
	],
	"./bznt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bznt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-80aacb"
	],
	"./bzrx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/bzrx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3e675a"
	],
	"./c20.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/c20.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-89a913"
	],
	"./cake.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cake.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7e06cb"
	],
	"./capp.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/capp.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-740465"
	],
	"./car.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/car.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-72a83f"
	],
	"./card.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/card.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-04d433"
	],
	"./cbat.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cbat.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b84fdd"
	],
	"./cbc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cbc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9f7b89"
	],
	"./cbt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cbt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3b3c26"
	],
	"./cccx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cccx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ab344d"
	],
	"./cdai.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cdai.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7c98e9"
	],
	"./cdt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cdt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e00b88"
	],
	"./cel.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cel.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f1b32c"
	],
	"./celr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/celr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-dd286b"
	],
	"./cennz.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cennz.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5ad0e9"
	],
	"./ceth.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ceth.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-26fa4b"
	],
	"./cfx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cfx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2dc11c"
	],
	"./chai.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/chai.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4db1a8"
	],
	"./chat.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/chat.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-36aab7"
	],
	"./chsb.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/chsb.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ce2841"
	],
	"./chz.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/chz.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-757999"
	],
	"./ckb.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ckb.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-997661"
	],
	"./clo.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/clo.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ba1475"
	],
	"./cloak.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cloak.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4d1ad0"
	],
	"./cmt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cmt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3d6a46"
	],
	"./cnd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cnd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2a4f4b"
	],
	"./cnx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cnx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7955b3"
	],
	"./comp.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/comp.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-cace6f"
	],
	"./coni.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/coni.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-8bdc83"
	],
	"./cosm.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cosm.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9d5ee2"
	],
	"./coti.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/coti.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1dede9"
	],
	"./cov.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cov.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-358fb8"
	],
	"./cova.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cova.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-07c828"
	],
	"./cpc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cpc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f2afca"
	],
	"./cpx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cpx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f339ec"
	],
	"./cre.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cre.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9d074d"
	],
	"./cream.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cream.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e50f4c"
	],
	"./cred.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cred.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-883e26"
	],
	"./crep.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/crep.svg",
		"vendors-node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-i-848ea8"
	],
	"./cro.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cro.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-db55f0"
	],
	"./crpt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/crpt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ee661a"
	],
	"./crv.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/crv.svg",
		"vendors-node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-i-b59b24"
	],
	"./cs.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cs.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-28ff51"
	],
	"./csai.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/csai.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-cfc71f"
	],
	"./csc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/csc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-fecfcc"
	],
	"./ctc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ctc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2771f8"
	],
	"./ctxc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ctxc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-804ac3"
	],
	"./cube.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cube.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7f0f26"
	],
	"./cusdc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cusdc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7f667c"
	],
	"./cv.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cv.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-82ec3d"
	],
	"./cvc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cvc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4b0037"
	],
	"./cvt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cvt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9768cc"
	],
	"./cwbtc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/cwbtc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-0c7d71"
	],
	"./czrx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/czrx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4fb2ba"
	],
	"./dadi.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dadi.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2919fc"
	],
	"./dag.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dag.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b2291d"
	],
	"./dai.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dai.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d33d1c"
	],
	"./dasc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dasc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7904ea"
	],
	"./dash.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dash.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-aa1a69"
	],
	"./dat.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dat.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-67fecf"
	],
	"./data.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/data.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9c72e0"
	],
	"./datx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/datx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-56d24c"
	],
	"./dbc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dbc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-177309"
	],
	"./dcc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dcc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-22aea8"
	],
	"./dcn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dcn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d18773"
	],
	"./dcr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dcr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a66753"
	],
	"./dct.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dct.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-73c66f"
	],
	"./ddd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ddd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3b972f"
	],
	"./default.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/default.svg"
	],
	"./dent.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dent.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-195fa3"
	],
	"./dfi.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dfi.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-8b094c"
	],
	"./dft.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dft.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-093331"
	],
	"./dgb.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dgb.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b25968"
	],
	"./dgd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dgd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-97b073"
	],
	"./dgtx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dgtx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ea44bf"
	],
	"./divi.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/divi.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-eed334"
	],
	"./dlt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dlt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-edc9cb"
	],
	"./dmt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dmt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-91fecd"
	],
	"./dnt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dnt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-6e01d8"
	],
	"./dock.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dock.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-45326b"
	],
	"./dodo.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dodo.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-870d18"
	],
	"./doge.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/doge.svg",
		"vendors-node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-i-582de8"
	],
	"./dor.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dor.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-99a81c"
	],
	"./dot.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dot.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-132042"
	],
	"./drgn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/drgn.svg",
		"vendors-node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-i-0c5292"
	],
	"./drop.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/drop.svg",
		"vendors-node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-i-8906e2"
	],
	"./dta.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dta.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d1ce82"
	],
	"./dtr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dtr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2766df"
	],
	"./dtx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dtx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-94d26b"
	],
	"./dxt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/dxt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4993d0"
	],
	"./edg.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/edg.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-827bef"
	],
	"./edo.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/edo.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-997c35"
	],
	"./efx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/efx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c14fd0"
	],
	"./egld.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/egld.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-793067"
	],
	"./egt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/egt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-86644b"
	],
	"./ekg.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ekg.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ca5898"
	],
	"./ekt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ekt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-29f74d"
	],
	"./ela.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ela.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-257883"
	],
	"./elec.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/elec.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a4de31"
	],
	"./elf.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/elf.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c330e0"
	],
	"./emc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/emc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e9edbf"
	],
	"./emc2.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/emc2.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-de9689"
	],
	"./eng.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/eng.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-695e18"
	],
	"./enj.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/enj.svg",
		"vendors-node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-i-a3fe93"
	],
	"./eos.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/eos.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a306ea"
	],
	"./eosdac.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/eosdac.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f884ad"
	],
	"./erd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/erd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4ca41d"
	],
	"./ern.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ern.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3bb99b"
	],
	"./esd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/esd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-605c49"
	],
	"./esp.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/esp.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-19034c"
	],
	"./ess.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ess.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-92a1cc"
	],
	"./etc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/etc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-179ce6"
	],
	"./eth.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/eth.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4eccae"
	],
	"./etn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/etn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-bb0cc8"
	],
	"./etp.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/etp.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a307f5"
	],
	"./etz.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/etz.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-8697cb"
	],
	"./evx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/evx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-da1b69"
	],
	"./ewt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ewt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-48c72f"
	],
	"./exrn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/exrn.svg",
		"vendors-node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-i-45743a"
	],
	"./exy.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/exy.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1a892e"
	],
	"./fct.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/fct.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-28aad0"
	],
	"./fet.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/fet.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e371f3"
	],
	"./fil.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/fil.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4a9214"
	],
	"./flow.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/flow.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-02db11"
	],
	"./fota.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/fota.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a61c9d"
	],
	"./frm.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/frm.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-6e90b2"
	],
	"./fsn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/fsn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-0ae345"
	],
	"./ft.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ft.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-54eba7"
	],
	"./ftm.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ftm.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e04e88"
	],
	"./ftt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ftt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d00949"
	],
	"./fuel.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/fuel.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-fc1bf3"
	],
	"./fun.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/fun.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-af23a4"
	],
	"./fxc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/fxc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d3bb19"
	],
	"./fxt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/fxt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4ef3b6"
	],
	"./gala.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/gala.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c72f41"
	],
	"./gdc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/gdc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b5d368"
	],
	"./gem.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/gem.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-06b60b"
	],
	"./gen.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/gen.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-450aff"
	],
	"./gno.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/gno.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b7310c"
	],
	"./gnt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/gnt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-058c7c"
	],
	"./gnx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/gnx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-daa81a"
	],
	"./go.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/go.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-48af2f"
	],
	"./goc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/goc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7d46ff"
	],
	"./got.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/got.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f59e66"
	],
	"./grin.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/grin.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d3ec39"
	],
	"./grs.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/grs.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-67f872"
	],
	"./grt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/grt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3ecc8b"
	],
	"./gsc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/gsc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e36f21"
	],
	"./gt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/gt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b6ca8f"
	],
	"./gtc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/gtc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-46087c"
	],
	"./gto.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/gto.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d49699"
	],
	"./gusd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/gusd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f7b282"
	],
	"./gvt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/gvt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-88739d"
	],
	"./gxs.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/gxs.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a50a70"
	],
	"./hav.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/hav.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-56ac40"
	],
	"./hbar.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/hbar.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-234d3b"
	],
	"./hc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/hc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9fea40"
	],
	"./hedg.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/hedg.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-44347b"
	],
	"./her.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/her.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-32df1f"
	],
	"./hex.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/hex.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5e4677"
	],
	"./hive.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/hive.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e44e3c"
	],
	"./hot-x.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/hot-x.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2ba8be"
	],
	"./hot.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/hot.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-8b506f"
	],
	"./hpb.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/hpb.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-6b70d9"
	],
	"./hsr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/hsr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d858e3"
	],
	"./ht.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ht.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ca8987"
	],
	"./hum.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/hum.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-292222"
	],
	"./husd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/husd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2ee7e2"
	],
	"./hvn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/hvn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b91977"
	],
	"./hydro.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/hydro.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d98945"
	],
	"./hyn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/hyn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2ac94b"
	],
	"./ibat.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ibat.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1220ed"
	],
	"./icn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/icn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-98d84f"
	],
	"./icx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/icx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-196033"
	],
	"./idai.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/idai.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-25158b"
	],
	"./idex.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/idex.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f9078e"
	],
	"./ieth.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ieth.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9f27fe"
	],
	"./ignis.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ignis.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f3e6cd"
	],
	"./iknc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/iknc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3197bf"
	],
	"./ilink.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ilink.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-20bf6e"
	],
	"./inb.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/inb.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5c0190"
	],
	"./ins.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ins.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c3e57f"
	],
	"./iost.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/iost.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2db078"
	],
	"./iota.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/iota.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-79462a"
	],
	"./iotx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/iotx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4b6a14"
	],
	"./iq.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/iq.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-6486ea"
	],
	"./irep.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/irep.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-cfc5df"
	],
	"./iris.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/iris.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3986e9"
	],
	"./isusd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/isusd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-bcb072"
	],
	"./iusdc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/iusdc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-82d133"
	],
	"./iwbtc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/iwbtc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f562c3"
	],
	"./izrx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/izrx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a24bd1"
	],
	"./jnt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/jnt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-699824"
	],
	"./jrt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/jrt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5c951a"
	],
	"./jst.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/jst.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a25162"
	],
	"./kava.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/kava.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-024914"
	],
	"./kcs.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/kcs.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-039fa8"
	],
	"./keep.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/keep.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-89260a"
	],
	"./key.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/key.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ca90e7"
	],
	"./kick.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/kick.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d3aa89"
	],
	"./kin.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/kin.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7d1e73"
	],
	"./klv.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/klv.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-db1171"
	],
	"./kmd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/kmd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e038fd"
	],
	"./knc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/knc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9657c6"
	],
	"./ksm.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ksm.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-814aa0"
	],
	"./lamb.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/lamb.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b96605"
	],
	"./land.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/land.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e98f25"
	],
	"./lba.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/lba.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1b0c08"
	],
	"./ldo.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ldo.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a25377"
	],
	"./lend.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/lend.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a13c0e"
	],
	"./leo.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/leo.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2d0c20"
	],
	"./link.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/link.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-96dd90"
	],
	"./lit.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/lit.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-18257a"
	],
	"./lky.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/lky.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-91292b"
	],
	"./loki.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/loki.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9c2069"
	],
	"./lon.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/lon.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-97754c"
	],
	"./loom.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/loom.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-8212ff"
	],
	"./lpt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/lpt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-91b823"
	],
	"./lqd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/lqd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ad4678"
	],
	"./lrc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/lrc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-abbf14"
	],
	"./lsk.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/lsk.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1a1f0c"
	],
	"./ltc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ltc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e9c2af"
	],
	"./lto.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/lto.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b66986"
	],
	"./lun.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/lun.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-44e4ff"
	],
	"./luna.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/luna.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9f9f4c"
	],
	"./lxt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/lxt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b85df2"
	],
	"./lym.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/lym.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-43730a"
	],
	"./maid.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/maid.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c49181"
	],
	"./man.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/man.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b872b6"
	],
	"./mana-old.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mana-old.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-dcb89f"
	],
	"./mana.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mana.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-df705c"
	],
	"./math.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/math.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-970c0d"
	],
	"./matic.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/matic.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-654ad9"
	],
	"./mbc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mbc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-8b3a72"
	],
	"./mco.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mco.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ecf0aa"
	],
	"./mcx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mcx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-dd90df"
	],
	"./mda.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mda.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1eb14f"
	],
	"./mds.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mds.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d331e3"
	],
	"./med.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/med.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-47d0ff"
	],
	"./medx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/medx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d7e010"
	],
	"./met.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/met.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-72c1cd"
	],
	"./mfg.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mfg.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4c0cce"
	],
	"./mft.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mft.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-141fed"
	],
	"./mir.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mir.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e5fc1e"
	],
	"./mith.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mith.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f91de5"
	],
	"./mkr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mkr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5e7508"
	],
	"./mln.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mln.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-6a35c7"
	],
	"./mod.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mod.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-533451"
	],
	"./mot.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mot.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-42cdc5"
	],
	"./mta.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mta.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-808355"
	],
	"./mth.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mth.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b5d6d6"
	],
	"./mtl.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mtl.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-34b439"
	],
	"./mtn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mtn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-65f3d5"
	],
	"./mvc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mvc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-62a3f8"
	],
	"./mvl.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mvl.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-aca8e4"
	],
	"./mvp.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mvp.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-03cda8"
	],
	"./mwat.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mwat.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-0702cb"
	],
	"./mwc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mwc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-8bb1ed"
	],
	"./mxm.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/mxm.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-74cc73"
	],
	"./myb.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/myb.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-92bf14"
	],
	"./nano.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nano.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-004717"
	],
	"./nas.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nas.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c9a6bb"
	],
	"./nav.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nav.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c8b9f1"
	],
	"./ncash.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ncash.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a2e0e1"
	],
	"./nct.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nct.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-6aab9d"
	],
	"./near.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/near.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-be5a0e"
	],
	"./nebl.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nebl.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a8d20a"
	],
	"./nec.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nec.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4caf3a"
	],
	"./neo.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/neo.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-75ffeb"
	],
	"./new.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/new.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ce2b44"
	],
	"./nex.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nex.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-950ab7"
	],
	"./nexo.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nexo.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-730d0b"
	],
	"./nexxo.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nexxo.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-743fe4"
	],
	"./ngc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ngc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e19cc2"
	],
	"./nkn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nkn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-752f2b"
	],
	"./nmr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nmr.svg",
		"vendors-node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-i-e80486"
	],
	"./noia.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/noia.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d51769"
	],
	"./nper.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nper.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3fe995"
	],
	"./npxs.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/npxs.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-afe318"
	],
	"./nrg.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nrg.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c9b83a"
	],
	"./nrve.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nrve.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-62920f"
	],
	"./nu.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nu.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-404a94"
	],
	"./nuls.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nuls.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-494dbf"
	],
	"./nxs.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nxs.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b586a5"
	],
	"./nxt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/nxt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1daffc"
	],
	"./oag.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/oag.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-cfa4b8"
	],
	"./oax.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/oax.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ae6fde"
	],
	"./ocean.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ocean.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b64283"
	],
	"./ocn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ocn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c08794"
	],
	"./ode.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ode.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-0db2bf"
	],
	"./ogn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ogn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-0ca38c"
	],
	"./okb.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/okb.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b771c5"
	],
	"./olt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/olt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ecb4be"
	],
	"./omg.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/omg.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-baa0e2"
	],
	"./one.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/one.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2816eb"
	],
	"./onion.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/onion.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-67b21a"
	],
	"./ont.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ont.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ce2a7a"
	],
	"./open.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/open.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-426e7b"
	],
	"./orbs.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/orbs.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-399944"
	],
	"./orc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/orc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-43c967"
	],
	"./orn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/orn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-6c8f3e"
	],
	"./ost.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ost.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-237eff"
	],
	"./ovc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ovc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3fea18"
	],
	"./oxt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/oxt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-810c1a"
	],
	"./pBTC.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/pBTC.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f4738d"
	],
	"./pai.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/pai.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-05455c"
	],
	"./pal.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/pal.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-123afb"
	],
	"./part.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/part.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3d1cb7"
	],
	"./pax.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/pax.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-874c90"
	],
	"./paxg.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/paxg.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-20d2ba"
	],
	"./pay.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/pay.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e5268b"
	],
	"./perl.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/perl.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-cf9843"
	],
	"./pivx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/pivx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-fbd95d"
	],
	"./plDAI.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/plDAI.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-69f00a"
	],
	"./plUSDC.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/plUSDC.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-407603"
	],
	"./play.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/play.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-eef04e"
	],
	"./plr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/plr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e0a567"
	],
	"./png.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/png.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5db8bb"
	],
	"./pnk.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/pnk.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ed63e9"
	],
	"./pnt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/pnt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-0b47b7"
	],
	"./poa.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/poa.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-6c8232"
	],
	"./poe.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/poe.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-578505"
	],
	"./poly.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/poly.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4d2da1"
	],
	"./pond.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/pond.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-03843a"
	],
	"./powr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/powr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-8d0b60"
	],
	"./ppay.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ppay.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d5d847"
	],
	"./ppc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ppc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7619b7"
	],
	"./ppp.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ppp.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7fdf3f"
	],
	"./ppt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ppt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-8977d2"
	],
	"./pre.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/pre.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-08d6e4"
	],
	"./prl.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/prl.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-936058"
	],
	"./pro.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/pro.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-0cddb0"
	],
	"./prq.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/prq.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5c14e9"
	],
	"./pst.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/pst.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e9bd30"
	],
	"./qash.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/qash.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3aaab3"
	],
	"./qbit.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/qbit.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ecff72"
	],
	"./qkc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/qkc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4fad67"
	],
	"./qlc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/qlc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-131a9c"
	],
	"./qnt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/qnt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-acc4d4"
	],
	"./qsp.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/qsp.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-29c57e"
	],
	"./qtum.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/qtum.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1ccd85"
	],
	"./r.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/r.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e87c80"
	],
	"./rae.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rae.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ece22e"
	],
	"./rari.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rari.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-490876"
	],
	"./ray.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ray.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a0c4e9"
	],
	"./rcn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rcn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9a1c9b"
	],
	"./rdd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rdd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a71fbe"
	],
	"./rdn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rdn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3bb113"
	],
	"./ren.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ren.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-29e673"
	],
	"./rep.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rep.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4e8331"
	],
	"./req.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/req.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7dcc9a"
	],
	"./rev.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rev.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-85d826"
	],
	"./rfox.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rfox.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-dacc72"
	],
	"./rhoc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rhoc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-8f3a71"
	],
	"./rif.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rif.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-8a04d4"
	],
	"./rlc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rlc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4c8a32"
	],
	"./rose.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rose.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d419d7"
	],
	"./rpx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rpx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-65b98f"
	],
	"./rsr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rsr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a051f1"
	],
	"./rsv.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rsv.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7a9524"
	],
	"./rune.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rune.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d5fc59"
	],
	"./rvn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/rvn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4f80d9"
	],
	"./s.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/s.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-83e023"
	],
	"./sai.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/sai.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-98cac0"
	],
	"./salt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/salt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d7a24c"
	],
	"./san.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/san.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f7d26a"
	],
	"./scrl.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/scrl.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-dd2c19"
	],
	"./scrt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/scrt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-497a26"
	],
	"./seele.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/seele.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-daa0b0"
	],
	"./sem.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/sem.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e21a9e"
	],
	"./sfp.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/sfp.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-163677"
	],
	"./shr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/shr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-50a885"
	],
	"./shuf.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/shuf.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-302d5c"
	],
	"./sia.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/sia.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4af35e"
	],
	"./skl.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/skl.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c24627"
	],
	"./sky.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/sky.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4098b0"
	],
	"./slt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/slt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-460d45"
	],
	"./smart.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/smart.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1f4bed"
	],
	"./snc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/snc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e61286"
	],
	"./sngls.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/sngls.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7b95fa"
	],
	"./snm.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/snm.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c45644"
	],
	"./snt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/snt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2ce60d"
	],
	"./snx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/snx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4651f2"
	],
	"./sol.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/sol.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-42e378"
	],
	"./soul.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/soul.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c6fab5"
	],
	"./spn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/spn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f90550"
	],
	"./srm.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/srm.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1f93c6"
	],
	"./stake.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/stake.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1760a1"
	],
	"./steem.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/steem.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e6bfad"
	],
	"./steth.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/steth.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5c6d60"
	],
	"./stmx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/stmx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-0198dd"
	],
	"./storj.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/storj.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-632e66"
	],
	"./storm.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/storm.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e28bdc"
	],
	"./strat.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/strat.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1ac4b7"
	],
	"./stx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/stx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c52619"
	],
	"./sub.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/sub.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5204fd"
	],
	"./super.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/super.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-801399"
	],
	"./suqa.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/suqa.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-671465"
	],
	"./sushi.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/sushi.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b30712"
	],
	"./suter.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/suter.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b10546"
	],
	"./swap.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/swap.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-8d36e3"
	],
	"./swth.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/swth.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c026ba"
	],
	"./sxdt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/sxdt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-207b1e"
	],
	"./sxp.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/sxp.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-05b7bc"
	],
	"./sys.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/sys.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9d722e"
	],
	"./tct.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/tct.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-fe5a08"
	],
	"./tel.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/tel.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-67af75"
	],
	"./tfuel.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/tfuel.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-450b96"
	],
	"./thc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/thc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-692436"
	],
	"./theta.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/theta.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c65cb1"
	],
	"./thr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/thr.svg",
		"vendors-node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-i-dd236a"
	],
	"./tio.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/tio.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a66591"
	],
	"./titan.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/titan.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-bbbeb7"
	],
	"./tkn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/tkn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-bee343"
	],
	"./tky.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/tky.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e4436d"
	],
	"./tnb.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/tnb.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d0f0de"
	],
	"./tnc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/tnc.svg",
		"vendors-node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-i-a0e306"
	],
	"./tnt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/tnt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-72201c"
	],
	"./tomo.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/tomo.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-268962"
	],
	"./tpay.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/tpay.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-23e02f"
	],
	"./trac.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/trac.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-fd1951"
	],
	"./trb.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/trb.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-fa51e4"
	],
	"./trig.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/trig.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-226bf9"
	],
	"./trtl.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/trtl.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-989b10"
	],
	"./trx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/trx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c608ad"
	],
	"./tryb.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/tryb.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-54dd96"
	],
	"./ttc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ttc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2d0e9f"
	],
	"./tube.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/tube.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-6e6f79"
	],
	"./tusd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/tusd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-75f628"
	],
	"./ubq.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ubq.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-bcc449"
	],
	"./ubt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ubt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-0a5991"
	],
	"./ult.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/ult.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-27369f"
	],
	"./uma.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/uma.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-03e8ab"
	],
	"./unfi.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/unfi.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3308ef"
	],
	"./uni.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/uni.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-306441"
	],
	"./unn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/unn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-e15c54"
	],
	"./uos.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/uos.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a2bd83"
	],
	"./upp.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/upp.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5b3ab2"
	],
	"./usd.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/usd.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7eca20"
	],
	"./usdc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/usdc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4bd039"
	],
	"./usds.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/usds.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-0b1ab9"
	],
	"./usdt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/usdt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a2cfe3"
	],
	"./utk.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/utk.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-34fa0f"
	],
	"./uuu.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/uuu.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a60856"
	],
	"./veri.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/veri.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-916432"
	],
	"./vest.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/vest.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-0a2931"
	],
	"./vet.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/vet.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-616ca7"
	],
	"./via.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/via.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-d44604"
	],
	"./vib.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/vib.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-009f15"
	],
	"./vibe.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/vibe.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-089ba2"
	],
	"./vidt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/vidt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3a837a"
	],
	"./vikky.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/vikky.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-937ee2"
	],
	"./vin.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/vin.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1601fe"
	],
	"./vite.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/vite.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-1edc1d"
	],
	"./viu.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/viu.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9005b3"
	],
	"./vlx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/vlx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9222f2"
	],
	"./vrs.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/vrs.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-714e11"
	],
	"./vsp.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/vsp.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7a17e2"
	],
	"./vsys.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/vsys.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-26dbe1"
	],
	"./vtc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/vtc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-543b43"
	],
	"./wabi.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/wabi.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-5bb937"
	],
	"./wan.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/wan.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a65423"
	],
	"./waves.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/waves.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b34eae"
	],
	"./wbtc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/wbtc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-042f22"
	],
	"./wct.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/wct.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-4d59cf"
	],
	"./whale.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/whale.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-28e70e"
	],
	"./wib.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/wib.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-a9d233"
	],
	"./wings.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/wings.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-87077e"
	],
	"./woo.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/woo.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-dd3388"
	],
	"./wpr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/wpr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-472652"
	],
	"./wrx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/wrx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-279877"
	],
	"./wtc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/wtc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-14b791"
	],
	"./wxt.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/wxt.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c0883d"
	],
	"./xas.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xas.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-cf12c5"
	],
	"./xchf.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xchf.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-83b2f4"
	],
	"./xem.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xem.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-21dbcb"
	],
	"./xin.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xin.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-993093"
	],
	"./xlm.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xlm.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-37db63"
	],
	"./xlq.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xlq.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-453842"
	],
	"./xmark.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xmark.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-b8f365"
	],
	"./xmr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xmr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-2d342d"
	],
	"./xmx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xmx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-099f2f"
	],
	"./xnk.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xnk.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-de8a70"
	],
	"./xns.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xns.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9694df"
	],
	"./xor.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xor.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-cbefaf"
	],
	"./xrp.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xrp.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-ecfd78"
	],
	"./xsn.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xsn.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-c2571c"
	],
	"./xsr.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xsr.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-31febe"
	],
	"./xtz.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xtz.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7e30e0"
	],
	"./xvg.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xvg.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-00d43d"
	],
	"./xyo.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xyo.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-213a1c"
	],
	"./xzc.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/xzc.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-8796f2"
	],
	"./yfi.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/yfi.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-239e68"
	],
	"./yoyo.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/yoyo.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-42a13c"
	],
	"./zai.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/zai.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-59475d"
	],
	"./zb.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/zb.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-3f6607"
	],
	"./zco.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/zco.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-f9941a"
	],
	"./zec.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/zec.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-eaa137"
	],
	"./zel.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/zel.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-30a3c4"
	],
	"./zen.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/zen.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-7d9939"
	],
	"./zil.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/zil.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-9bb79a"
	],
	"./zks.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/zks.svg",
		"vendors-node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-i-68971c"
	],
	"./zrx.svg": [
		"./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref!./node_modules/react-crypto-icons/lib/assets/zrx.svg",
		"node_modules_svgr_webpack_lib_index_js_svgo_titleProp_ref_node_modules_react-crypto-icons_lib-07fcbf"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./node_modules/react-crypto-icons/lib/assets lazy recursive !!./node_modules/@svgr/webpack/lib/index.js?+svgo,+titleProp,+ref! ^\\.\\/.*\\.svg$";
module.exports = webpackAsyncContext;